import { lazy } from 'react';
import { Route } from 'react-router-dom';

const BankTransfer = lazy(() => import('../components/bank-transfer'));

const paymentRoutes = (
	<>
		<Route path="/bank-transfer" element={<BankTransfer />} />
	</>
);

export default paymentRoutes;
